import React from 'react'

interface BlockedPermissionsProps {
  title: string
  subTitle?: string
}

const BlockedPermissions: React.FC<BlockedPermissionsProps> = ({
  title,
  subTitle = 'Contact sales to review your plan'
}) => {
  if (!title) return <></>
  return (
    <div className='w-full bg-[#FAFAFA] rounded-lg p-4 border-2 border-[#F0F0F0] '>
      <h3 className='font-medium text-carbon'>{title}</h3>
      <p className='text-sm text-coal-dark'>{subTitle}</p>
    </div>
  )
}

export default BlockedPermissions
